import {Button} from "react-bootstrap";
import DepartureBoard from "./icons/DepartureBoard";

/**
 * Przycisk przekierowywania do wirtualnej tablicy SDIP w Portalu Pasażera
 * @param {string|number} idStation ID stacji
 * @returns {JSX.Element}
 * @constructor
 */
export default function CSDIPButton({idStation}) {
    const link = "https://l.plk-sa.pl/" + idStation
    return (
        <Button variant={"outline-primary"} href={link} target={"_blank"}>
            <DepartureBoard/>
        </Button>
    )
}
